import { render, staticRenderFns } from "./MarkdownMessageDialog.vue?vue&type=template&id=2750d001&scoped=true"
import script from "./MarkdownMessageDialog.vue?vue&type=script&lang=js"
export * from "./MarkdownMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./MarkdownMessageDialog.vue?vue&type=style&index=0&id=2750d001&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2750d001",
  null
  
)

export default component.exports